import React, { useEffect, useState } from "react";
import { cn } from "../../lib/utils";

export function TopProgressBar({ isLoading }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (isLoading) {
      setProgress(0);
      const interval = setInterval(() => {
        setProgress((prev) => (prev >= 95 ? prev : prev + Math.random() * 10));
      }, 300);

      return () => clearInterval(interval);
    } else {
      setProgress(100);
      const timeout = setTimeout(() => setProgress(0), 500);
      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  return (
    <div
      className={cn(
        "fixed left-0 top-16 z-30 h-1 w-full overflow-hidden bg-muted",
        progress === 0 && "hidden"
      )}
    >
      <div
        className="h-full bg-primary transition-[width] duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
}
